module.exports = __webpack_public_path__ + "img/12 parque.665e0f78.jpg";